// extracted by mini-css-extract-plugin
module.exports = {"numericInputContainerGroup":"WorkspacePostingDialog__numericInputContainerGroup___naPjY","centerRadioButtonItem":"WorkspacePostingDialog__centerRadioButtonItem___hsLCO"};